import { ReactNode, useContext, useMemo } from "react"
import { ScrollContext } from "./context"

/* eslint-disable react-hooks/exhaustive-deps */

type Props = {
  id: string
  title: string
  children: ReactNode
} & React.HTMLProps<HTMLButtonElement>

const Section = ({ id, title, children, ...rest }: Props) => {
  const { registerRef } = useContext(ScrollContext)
  const ref = useMemo(() => registerRef(id), [id])

  return (
    <section {...rest} ref={ref} data-title={title}>
      {children}
    </section>
  )
}

export default Section
